exports.Errors = {
  GetSession: {
    Message: 'Error while getting session',
    Code: 'GetSession'
  },
  SwitchContainers: {
    Message: 'Error while switching containers',
    Code: 'SwitchContainers'
  },
  UpdateEula: {
    Message: 'Error while updating eula.',
    Code: 'UpdateEula'
  }
};

exports.Events = {
  CONTAINER_CHANGED: 'XBS-Container-Changed',
  STORAGE: 'storage',
};

exports.PlatformStatus = {
  LOADING: 'XBS-Platform-Loading',
  LOADED: 'XBS-Platform-Loaded'
};

exports.Methods = {
  Post: 'POST',
  Get: 'GET',
  Put: 'PUT',
  Delete: 'DELETE',
  Options: 'OPTIONS',
  Any: 'ANY'
};

exports.UserUri = '/v1/user';
exports.SessionURL = '/v1/get-product-session';